export const mockSales = [
  {
    id: '1',
    customer_name: 'Ayşe Yılmaz',
    phone: '0532 123 45 67',
    sale_date: '2026-06-01',
    product_description: 'Deri ceket, kış koleksiyonu',
    total_amount: 4500,
    paid_amount: 4500,
    remaining_amount: 0,
    payment_type: 'Nakit',
    status: 'Tamamlandı',
    notes: '',
    created_at: '2026-06-01T10:00:00Z',
  },
  {
    id: '2',
    customer_name: 'Fatma Kaya',
    phone: '0533 456 78 90',
    sale_date: '2026-06-01',
    product_description: 'İpek elbise, özel tasarım',
    total_amount: 3200,
    paid_amount: 1200,
    remaining_amount: 2000,
    payment_type: 'Veresiye',
    status: 'Kısmi Ödendi',
    notes: 'Gelecek hafta kalanı ödenecek',
    created_at: '2026-06-01T11:30:00Z',
  },
  {
    id: '3',
    customer_name: 'Zeynep Demir',
    phone: '0535 789 01 23',
    sale_date: '2026-05-30',
    product_description: 'Kot pantolon, 3 adet',
    total_amount: 1800,
    paid_amount: 1800,
    remaining_amount: 0,
    payment_type: 'Kart',
    status: 'Tamamlandı',
    notes: '',
    created_at: '2026-05-30T14:00:00Z',
  },
  {
    id: '4',
    customer_name: 'Merve Şahin',
    phone: '0536 234 56 78',
    sale_date: '2026-05-28',
    product_description: 'Yazlık bluz, 5 adet',
    total_amount: 2500,
    paid_amount: 500,
    remaining_amount: 2000,
    payment_type: 'Parçalı',
    status: 'Kısmi Ödendi',
    notes: '2 taksit kaldı',
    created_at: '2026-05-28T09:00:00Z',
  },
  {
    id: '5',
    customer_name: 'Selin Çelik',
    phone: '0537 567 89 01',
    sale_date: '2026-05-25',
    product_description: 'Abiye elbise',
    total_amount: 5800,
    paid_amount: 0,
    remaining_amount: 5800,
    payment_type: 'Veresiye',
    status: 'Bekliyor',
    notes: 'Vade tarihi 10 Haziran',
    created_at: '2026-05-25T16:00:00Z',
  },
  {
    id: '6',
    customer_name: 'Burcu Aydın',
    phone: '0538 890 12 34',
    sale_date: '2026-05-20',
    product_description: 'Kadın ayakkabı, 2 çift',
    total_amount: 2200,
    paid_amount: 2200,
    remaining_amount: 0,
    payment_type: 'Havale',
    status: 'Tamamlandı',
    notes: '',
    created_at: '2026-05-20T11:00:00Z',
  },
  {
    id: '7',
    customer_name: 'Gizem Özdemir',
    phone: '0539 123 45 67',
    sale_date: '2026-05-18',
    product_description: 'Kışlık mont, kürklü',
    total_amount: 7500,
    paid_amount: 2500,
    remaining_amount: 5000,
    payment_type: 'Parçalı',
    status: 'Kısmi Ödendi',
    notes: '3 taksit kaldı',
    created_at: '2026-05-18T13:00:00Z',
  },
  {
    id: '8',
    customer_name: 'Aslı Karaca',
    phone: '0540 456 78 90',
    sale_date: '2026-05-15',
    product_description: 'Çanta, deri',
    total_amount: 1900,
    paid_amount: 1900,
    remaining_amount: 0,
    payment_type: 'Nakit',
    status: 'Tamamlandı',
    notes: '',
    created_at: '2026-05-15T10:00:00Z',
  },
  {
    id: '9',
    customer_name: 'Ece Yıldız',
    phone: '0541 789 01 23',
    sale_date: '2026-05-12',
    product_description: 'Eşarp, ipek, 3 adet',
    total_amount: 1200,
    paid_amount: 0,
    remaining_amount: 1200,
    payment_type: 'Veresiye',
    status: 'Gecikti',
    notes: 'Vade 1 Hazirandı, hâlâ ödenmedi',
    created_at: '2026-05-12T15:00:00Z',
  },
  {
    id: '10',
    customer_name: 'Nazlı Koç',
    phone: '0542 234 56 78',
    sale_date: '2026-05-10',
    product_description: 'Kot ceket, kışlık',
    total_amount: 2800,
    paid_amount: 2800,
    remaining_amount: 0,
    payment_type: 'Kart',
    status: 'Tamamlandı',
    notes: '',
    created_at: '2026-05-10T09:00:00Z',
  },
];